module.exports = __webpack_public_path__ + "static/media/VU2110F0.ee034655.png";